import helpContext from "../../helpers/helpContext";
import { cloneDeep } from "lodash";
import { dispatch } from "@rematch/core";
import { push } from "react-router-redux";
import { toastr } from "react-redux-toastr";

import {
  app,
  organizationService,
  userCacheService,
  accountUserWorkspacesService,
  userWorkspaceCacheService,
  ssoConfigService,
  helpContentService,
  AccountSubscriptionDetailsService,
  pricingTableService,
  downloadFileService,
  serviceFatcory,
  categoryPublicService,
  AccountsUsageService,
  ConsumptionBillingService,
  userPreferencesService,
} from "../../services/feathers.service";

import Graph from "../../helpers/cache/graph";

import AuthService from "../../services/auth0.service";

const cacheConfig = require("../../helpers/userCacheConfig.json");
let authService = null;
const SSO_PATHID = "aspenify_sso_path";

cacheConfig.forEach(function (cacheConfigItem) {
  app.service(cacheConfigItem.serviceName).on("created", (createdObject) => {
    const payload = {
      createdObject,
      cacheConfigItem,
    };
    dispatch.app.handleCreateEvent(payload);
  });

  app.service(cacheConfigItem.serviceName).on("updated", (updatedObject) => {
    const payload = {
      updatedObject,
      cacheConfigItem,
    };
    dispatch.app.handleUpdateEvent(payload);
  });

  app.service(cacheConfigItem.serviceName).on("patched", (patchedObject) => {
    const payload = {
      patchedObject,
      cacheConfigItem,
    };
    dispatch.app.handlePatchEvent(payload);
  });

  app.service(cacheConfigItem.serviceName).on("removed", (deletedObject) => {
    const payload = {
      deletedObject,
      cacheConfigItem,
    };
    dispatch.app.handleRemovedEvent(payload);
  });
});

app.service("contents").on("bulkImport", (eventData) => {
  dispatch.app.refreshCache();
});

const getObjectFromVertex = function (vertexObject) {
  const type = vertexObject[Object.getOwnPropertySymbols(vertexObject)[0]];
  const object = Object.keys(vertexObject).reduce(function (obj, k) {
    obj[k] = vertexObject[k];
    return obj;
  }, {});
  return { type, object };
};

const isPartOfMyAccount = function (graph, entityData) {
  const accountId = entityData.accountId.toString();
  if (accountId) {
    //check for account
    if (graph.hasVertex(accountId)) {
      const account = graph.vertex(accountId);
      if (account.props.addOnMetaData.isOwner) {
        return true;
      }
    }
  }
  return false;
};

const isPartOfMyWorkspace = function (graph, entityData) {
  const workspaceId = entityData.organizationId.toString();
  if (workspaceId) {
    //check for account
    if (graph.hasVertex(workspaceId)) {
      const workspace = graph.vertex(workspaceId);
      if (
        workspace.props.addOnMetaData.isOwner ||
        workspace.props.addOnMetaData.isIndirectOwner
      ) {
        return true;
      }
    }
  }
  return false;
};

const amITheCreatorOfThis = function (graph, entityData, loggedInUserId) {
  if(entityData && entityData.createdBy){
    const createdBy = entityData.createdBy.toString();
    if (createdBy) {
      if (createdBy === loggedInUserId) {
        return true;
      }
    }
    return false;
  }
};

const isPartOfMyTeam = function (graph, entityData) {
  const teamId = entityData.teamId.toString();
  if (teamId) {
    //check for account
    if (graph.hasVertex(teamId)) {
      const team = graph.vertex(teamId);
      if (
        team.props.addOnMetaData.isOwner ||
        team.props.addOnMetaData.isIndirectOwner
      ) {
        return true;
      }
    }
  }
  return false;
};

const isPartOfMySubOrg = function (graph, entityData) {
  const teamId = entityData.parentOrganizationId.toString();
  if (teamId) {
    //check for account
    if (graph.hasVertex(teamId)) {
      const team = graph.vertex(teamId);
      if (
        team.props.addOnMetaData.isOwner ||
        team.props.addOnMetaData.isIndirectOwner
      ) {
        return true;
      }
    }
  }
  return false;
};

const AmIParticipantForPlaybook = function (graph, entityData) {
  const edgesFromRoot = Array.from(graph.outEdges("root"));
  const loggedInUserObject = getObjectFromVertex(edgesFromRoot[0].target);
  const loggedInUserId = loggedInUserObject.object.id;

  if (entityData.participants && entityData.participants.length > 0) {
    entityData.participants.forEach(function (participant) {
      const accountUserId = participant.accountUserId.toString();
      if (loggedInUserId === accountUserId) {
        return true;
      }
    });
  }
  return false;
};

//true for entities - workspace, team, playbook and initiative
const isEntityPartOfUserGraph = function (
  graph,
  cacheConfigItem,
  entityData,
  loggedInUserId
) {
  const entityType = cacheConfigItem.cacheType;

  switch (entityType) {
    case "Account":
      return false;
    case "AccountUser":
      return false;
    case "Workspace":
      return isPartOfMyAccount(graph, entityData);
    case "Team":
      return (
        isPartOfMyWorkspace(graph, entityData) ||
        isPartOfMySubOrg(graph, entityData) ||
        amITheCreatorOfThis(graph, entityData, loggedInUserId)
      );
    case "Content":
      return (
        isPartOfMyWorkspace(graph, entityData) ||
        amITheCreatorOfThis(graph, entityData, loggedInUserId)
      );
    case "Playbook":
      return (
        isPartOfMyWorkspace(graph, entityData) ||
        AmIParticipantForPlaybook(graph, entityData) ||
        amITheCreatorOfThis(graph, entityData, loggedInUserId)
      );
    case "Initiative":
      return (
        isPartOfMyWorkspace(graph, entityData) ||
        isPartOfMyTeam(graph, entityData) ||
        amITheCreatorOfThis(graph, entityData, loggedInUserId)
      );
    default:
      return false;
  }
};

const initialState = {
  isUserLoggedIn: false,
  user: null,
  ssoConfig: null,
  ssoConfigError: false,
  userCache: null,
  userCacheHash: null,
  organizations: null,
  orgCreationError: null,
  currentContext: "",
  helpContext: "",
  selectedOrganisation: "",
  selectedAccount: "",
  accountSubscriptionDetail: null,
  isAddOrgModalOpen: false,
  collapsedResourcePaneIndex: null,
  collapsedResourcePaneIndexTemp: null,
  baseModuleType: null,
  envData: {},
  helpContent: null,
  isDefaultAccountSelected: false,
  accountDetail: null,
  isProd: false,
  showToolbarFlag: false,
  teamsListViewFlag: true,
  routeParams: {},
  tableFilterQuery: {},
  publicCategoryList: [],
  selectedBaseCategory: "",
  selectedCategory: "",
  selectedSubCategory: "",
  selectedContentScope: "",
  contentPath: "",
  playbookPath: "",
  isActiveModal: false,
  subscriptionLimitError: false,
  subscriptionLimitProps: null,
  topUpCreditsModal: false,
  topUpCreditsProps: null,
  activeGenerationBlockedModal: false,
  activeGenerationBlockedProps: null,
  selectedWorkspaceState:null
};

export default {
  state: initialState,
  reducers: {

    setIsActiveModal(state, payload) {
      return {
        ...state,
        isActiveModal: payload
      };
      
    },
    isUserLoggedIn(state, payload) {
      return {
        ...state,
        isUserLoggedIn: payload,
      };
    },
    
    setSubscriptionLimitError(state, payload) {
      return {
        ...state,
        subscriptionLimitError: payload,
      };
    },

    setSubscriptionLimitProps(state, payload) {
      return {
        ...state,
        subscriptionLimitProps: payload,
      };
    },

    setActiveGenerationBlockedModal(state, payload) {
      return {
        ...state,
        activeGenerationBlockedModal: payload,
      };
    },

    setActiveGenerationBlockedProps(state, payload) {
      return {
        ...state,
        activeGenerationBlockedProps: payload,
      };
    },

    setTopUpCreditsModal(state, payload) {
      return {
        ...state,
        topUpCreditsModal: payload,
      };
    },

    setTopUpCreditsProps(state, payload) {
      return {
        ...state,
        topUpCreditsProps: payload,
      };
    },

    setSelectedWorkspaceState(state, payload) {
      return {
        ...state,
        selectedWorkspaceState: payload,
      };
    },

    setUser(state, payload) {
      return {
        ...state,
        user: payload,
      };
    },

    setSSOConfig(state, payload) {
      return {
        ...state,
        ssoConfig: payload,
      };
    },
    setSSOConfigError(state, payload) {
      return {
        ...state,
        ssoConfigError: payload,
      };
    },
    updateSelectedOrgTimeZone(state, payload) {
      const selectedOrganisation = cloneDeep(state.selectedOrganisation);
      selectedOrganisation.timeZone = payload;
      return {
        ...state,
        selectedOrganisation,
      };
    },

    addNewOrganization(state, payload) {
      if (state.user.email === payload.email) {
        let orgFound = false;
        for (let orgData of state.organizations) {
          if (orgData.id === payload.organization) {
            orgFound = true;
            break;
          }
        }
        //if org not found, add it to user's org list
        if (!orgFound) {
          const userOrgObject = {
            role: payload.role,
            _id: payload.organization,
            name: payload.organizationName,
            id: payload.organization,
            timeZone: payload.timeZone,
          };

          let organizations = cloneDeep(state.organizations);
          organizations.push(userOrgObject);
          return {
            ...state,
            organizations: organizations,
          };
        }
      }
      return state;
    },
    setupNewOrganization(state, payload) {
      return {
        ...state,
        organizations: payload.accountUserWorkspaces,
      };
    },
    setUserCache(state, payload) {
      return {
        ...state,
        userCache: payload,
      };
    },
    setUserCacheHash(state, payload) {
      return {
        ...state,
        userCacheHash: payload,
      };
    },
    setHelpContent(state, payload) {
      return {
        ...state,
        helpContent: payload,
      };
    },
    setCurrentContext(state, payload) {
      return {
        ...state,
        currentContext: payload,
      };
    },
    setHelpContext(state, payload) {
      return {
        ...state,
        helpContext: payload,
      };
    },

    addOrgModalOpen(state, payload) {
      return {
        ...state,
        isAddOrgModalOpen: payload,
        orgCreationError: "",
      };
    },

    updateBasicUserDetail(state, payload) {
      let userDetails = cloneDeep(state.user);
      if (payload.firstName) {
        userDetails.firstName = payload.firstName;
      }
      if (payload.lastName) {
        userDetails.lastName = payload.lastName;
      }
      if (payload.profilePic) {
        userDetails.profilePic = payload.profilePic;
      }
      return {
        ...state,
        user: userDetails,
      };
    },

    setOrganisation(state, payload) {
      return {
        ...state,
        selectedOrganisation: payload,
      };
    },

    setAccountDetails(state, payload) {
      return {
        ...state,
        selectedAccount: payload,
      };
    },
    setAccountDetailsUserList(state, payload) {
      let selectedAccount = state.selectedAccount;
      let users = [];
      for (let index = 0; index < payload.length; index++) {
        users[index] = payload[index];
        users[index]["id"] = payload[index];
      }
      selectedAccount["users"] = users;
      return {
        ...state,
        selectedAccount: selectedAccount,
      };
    },
    selectSingleAccount(state, payload) {
      return {
        ...state,
        accountDetail: payload,
      };
    },
    accountSubDetails(state, payload) {
      return {
        ...state,
        accountSubscriptionDetail: payload,
      };
    },

    setOrgCreationError(state, payload) {
      let error = "Error while creating new workspace";
      if (payload.message.indexOf("already exists") !== -1) {
        error = "Workspace with same name already exists.";
      }
      if (payload.message.indexOf("Subscription Limit Error") !== -1) {
        error = "Can't create new Workspace as Subscription Limit is reached";
      }
      return {
        ...state,
        orgCreationError: error,
      };
    },

    collapsedResourcePane(state, payload) {
      return {
        ...state,
        collapsedResourcePaneIndex: payload,
      };
    },

    collapsedResourcePaneTemp(state, payload) {
      return {
        ...state,
        collapsedResourcePaneIndexTemp: payload,
      };
    },

    baseModule(state, payload) {
      return {
        ...state,
        baseModuleType: payload,
      };
    },

    setEnvData(state, payload) {
      return {
        ...state,
        envData: payload,
      };
    },

    setShowPricingTableEnv(state, payload) {
      return {
        ...state,
        isProd: payload,
      };
    },

    checkDefaultAccount(state, payload) {
      return {
        ...state,
        isDefaultAccountSelected: payload,
      };
    },
    setShowToolbarFlag(state, payload) {
      return {
        ...state,
        showToolbarFlag: payload,
      };
    },
    setTeamListViewFlag(state, payload) {
      return {
        ...state,
        teamsListViewFlag: payload,
      };
    },
    setRouteParams(state, payload) {
      return {
        ...state,
        routeParams: payload,
      };
    },
    setTableFilterQuery(state, payload) {
      return {
        ...state,
        tableFilterQuery: payload,
      };
    },
    setPublicBasecategory(state, payload) {
      return {
        ...state,
        publicCategoryList: payload,
      };
    },
    addPreferencesToUser(state, payload) {
      return {
        ...state,
        user: {
          ...state.user,
          preferences: payload,
        },
      };
    },
    updatePreferencesToUser(state, payload) {
      return {
        ...state,
        user: {
          ...state.user,
          preferences: {
            ...state.user.preferences,
            ...payload,
          },
        },
      };
    },
    setSelectedBaseCategory(state, payload) {
      return {
        ...state,
        selectedBaseCategory: payload,
      };
    },
    setSelectedCategory(state, payload) {
      return {
        ...state,
        selectedCategory: payload,
      };
    },
    setSelectedSubCategory(state, payload) {
      return {
        ...state,
        selectedSubCategory: payload,
      };
    },
    setSelectedContentScope(state, payload) {
      return {
        ...state,
        selectedContentScope: payload,
      };
    },
    setContentPath(state, payload) {
      return {
        ...state,
        contentPath: payload,
      };
    },
    setPlaybookPath(state, payload) {
      return {
        ...state,
        playbookPath: payload,
      };
    },
    clear(state) {
      return { ...initialState };
    },
  },

  effects: {
    modifyUserName(payload) {
      dispatch.app.updateBasicUserDetail(payload);
    },

    async setSelectedOrganisationData(payload) {
      try {
      let query = {
        $populate: [{ path: "integrations.id", populate: "id _id label" }],
      };
      const orgData = await organizationService.get(payload.id, {
        query: query,
      });
      if (orgData) {
        payload.timeZone = orgData.timeZone;
        payload.users = orgData.users;
        payload.fullControl = orgData.fullControl;
        payload.integrations = orgData.integrations;
        payload.publicLibraryAccess = orgData.publicLibraryAccess;
        payload.autoSignUp = orgData.autoSignUp
      }
      if (!payload.id) {
        payload.id = payload._id;
      }
      const userWorkspaceCacheObj = await userWorkspaceCacheService.get(
        orgData._id
      );
      await dispatch.app.setUserCache(userWorkspaceCacheObj.obj);

      dispatch.app.setOrganisation(payload);
      return true;
      } catch (error) {
        console.log("error ",error)
      }
      
    },

    async setSelectedAccountData(payload) {
      dispatch.app.setAccountDetails(payload);
      return true;
    },

    async setSelectedAccountDataUserList(payload) {
      dispatch.app.setAccountDetailsUserList(payload);
      return true;
    },

    async setAccountSubscriptionDetails(payload) {
      const accSubDetails = await AccountSubscriptionDetailsService.get(
        payload
      );
      let billingDefaults = await ConsumptionBillingService.find({query: { type: 'default' } });
      let accountsUsageData = await AccountsUsageService.find({
                            query: {
                                accountId: payload,
                                planExpiryDate: { $gt: new Date() }
                            }
                        });
      if(billingDefaults && billingDefaults.data && billingDefaults.data.length > 0 && accSubDetails){
        let defaults = billingDefaults.data[0].defaults;
        accSubDetails['consumptionDefaults'] = defaults;
      }
      if(accountsUsageData && accountsUsageData.data && accountsUsageData.data.length > 0 && accSubDetails){
        let usageData = accountsUsageData.data[0];
        accSubDetails['usageMeter'] = usageData.usageMeter;
        accSubDetails['planExpiryDate'] = usageData.planExpiryDate;
        accSubDetails['createdAt'] = usageData.createdAt;
      }
      dispatch.app.accountSubDetails(accSubDetails);
      return true;
    },
    async setHelpContentData() {
      const helpContent = await helpContentService.find({});
      dispatch.app.setHelpContent(helpContent);
      return true;
    },
    async setSingleAccountDetails(payload) {
      dispatch.app.selectSingleAccount(payload);
      return true;
    },
    async refreshCache(payload, rootState) {
      if (rootState.app.selectedOrganisation.id) {
        const userWorkspaceCacheObj = await userWorkspaceCacheService.get(
          rootState.app.selectedOrganisation.id
        );
        dispatch.app.setUserCache(userWorkspaceCacheObj.obj);
      } else {
        const userCacheObject = await userCacheService.get(
          rootState.app.user._id
        );
        // const cacheHash = rootState.app.userCacheHash;
        // if (cacheHash !== userCacheObject.hash) {
        dispatch.app.setUserCache(userCacheObject.obj);
      }
      return true;
    },
    async addNewWorkspace(payload) {
      try {
        let organizationObj = {
          name: payload.workspaceName,
          accountId: payload.accountId,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          users: [
            {
              name: payload.user.name,
              accountUserId: payload.user._id,
              role: "workspaceOwner",
            },
          ],
        };
        const createdWorkspaceDetails = await organizationService.create(
          organizationObj
        );
        let setWorkspacePayload = {
          selectedWorkspace: {
            role: "workspaceOwner",
            _id: createdWorkspaceDetails._id,
            name: createdWorkspaceDetails.name,
            timeZone: createdWorkspaceDetails.timeZone,
            id: createdWorkspaceDetails._id,
          },
          accountUserWorkspaces: [],
        };

        let allAccountUserWorkspaces = await accountUserWorkspacesService.find({
          query: {
            accountUserId: payload.user._id,
            accountId: payload.accountId,
          },
        });
        dispatch.account.setWorkspacesTotalCount(
          allAccountUserWorkspaces.data[0].organizations.length
        );

        setWorkspacePayload.accountUserWorkspaces =
          allAccountUserWorkspaces.data[0].organizations;
        dispatch.app.setupNewOrganization(setWorkspacePayload);
        dispatch.organizationUnit.updateOrganization({
          _id: createdWorkspaceDetails._id,
          fullControl: true,
        }); // KLM-9030
        dispatch.app.addOrgModalOpen(false);
        //dispatch.initiatives.clear();
        dispatch.app.setAccountSubscriptionDetails(payload.accountId);
        if (payload.redirectTo === "workspace") {
          dispatch.app.setCurrentContext("workspace/home");
          return dispatch(
            push(
              "/app/" +
                payload.accountId +
                "/_ws/" +
                createdWorkspaceDetails._id +
                "/home"
            )
          );
        } else {
          //return dispatch(push(`/app/${payload.accountId}/dashboard`));
        }
      } catch (err) {
        dispatch.app.setOrgCreationError(err);
        throw err;
      }
    },
    async addNewWorkspaceFreemiumUser(payload,state) {
      try {
        payload.user = state.app.user;
        let organizationObj = {
          name: payload.workspaceName,
          accountId: payload.accountId,
          createAccountUserWorkspace:true,
          fullControl: true,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          users: [
            {
              name: payload.user.name,
              accountUserId: payload.user._id,
              role: "workspaceOwner",
            },
          ],
        };
        const createdWorkspaceDetails = await organizationService.create(
          organizationObj
        );
        let setWorkspacePayload = {
          selectedWorkspace: {
            role: "workspaceOwner",
            _id: createdWorkspaceDetails._id,
            name: createdWorkspaceDetails.name,
            timeZone: createdWorkspaceDetails.timeZone,
            id: createdWorkspaceDetails._id,
          },
          accountUserWorkspaces: [],
        };
        let allAccountUserWorkspaces = await accountUserWorkspacesService.find({
          query: {
            accountUserId: payload.user._id,
            accountId: payload.accountId,
          },
        });
        dispatch.account.setWorkspacesTotalCount(
          allAccountUserWorkspaces.data[0].organizations.length
        );

        // if (allAccountUserWorkspaces.data && allAccountUserWorkspaces.data.length > 0) {
        //   const accountUserWorkspaceId = allAccountUserWorkspaces.data[0]._id;
        //   await accountUserWorkspacesService.patch(accountUserWorkspaceId, {
        //     organizations: allAccountUserWorkspaces.data[0].organizations.map(org => ({
        //       ...org,
        //       default: org.id.toString() === createdWorkspaceDetails._id.toString()
        //     }))
        //   });
        // }

        setWorkspacePayload.accountUserWorkspaces =
          allAccountUserWorkspaces.data[0].organizations;
          await dispatch.app.setSelectedOrganisationData(allAccountUserWorkspaces.data[0].organizations[0]);
        dispatch.app.setupNewOrganization(setWorkspacePayload);
        dispatch.organizationUnit.updateOrganization({
          _id: createdWorkspaceDetails._id,
          fullControl: true,
        });
        dispatch.app.addOrgModalOpen(false);
        dispatch.app.refreshCache();
        dispatch.app.setAccountSubscriptionDetails(payload.accountId);
      } catch (err) {
        dispatch.app.setOrgCreationError(err);
        throw err;
      }
    },
    cacheCleanup(payload) {
      dispatch.login.clear();
      dispatch.invite.clear();
      dispatch.register.clear();
      dispatch.profile.clear();
      dispatch.forgot.clear();
      dispatch.reset.clear();
      dispatch.organizationUnit.clear();
      dispatch.organizationTab.clear();
      dispatch.community.clear();
      dispatch.users.clear();
      dispatch.lifeCycle.clear();
      dispatch.content.clear();
      dispatch.createPack.clear();
      dispatch.notifications.clear();
      dispatch.initiatives.clear();
    },

    async setCollapsedResourcePaneIndex(payload) {
      dispatch.app.collapsedResourcePane(payload);
    },
    async setCollapsedResourcePaneIndexTemp(payload) {
      dispatch.app.collapsedResourcePaneTemp(payload);
    },
    async baseModuleType(payload) {
      dispatch.app.baseModule(payload);
    },
    async handleCreateEvent(payload, rootState) {
      if (rootState.app.isUserLoggedIn) {
        const createdObject = payload.createdObject;
        const cacheConfigItem = payload.cacheConfigItem;
        const graph = Graph.fromObject(rootState.app.userCache);
        const entityId = createdObject._id.toString();
        const loggedInUserId = rootState.app.user._id.toString();
        if (!graph.hasVertex(entityId)) {
          if (
            isEntityPartOfUserGraph(
              graph,
              cacheConfigItem,
              createdObject,
              loggedInUserId
            )
          ) {
            dispatch.app.refreshCache();
          }
        }

        if (
          rootState.app.isUserLoggedIn &&
          rootState.app.selectedOrganisation &&
          rootState.app.selectedOrganisation.id &&
          createdObject.organizationId &&
          rootState.app.selectedOrganisation.id.toString() ===
            createdObject.organizationId.toString()
        ) {
          if (
            cacheConfigItem.serviceName === "contents" &&
            rootState.app.currentContext === "content"
          ) {
            let contentPayload = {
              organizationId: createdObject.organizationId,
              accountId: createdObject.accountId,
              userid: loggedInUserId,
            };
            await dispatch.content.getAllContents(contentPayload);
            await dispatch.content.getContentsCount({
              organizationId: createdObject.organizationId,
              accountId: createdObject.accountId,
              value: "All",
            });
          }

          if (
            cacheConfigItem.serviceName === "playbooks" &&
            rootState.app.currentContext === "designer"
          ) {
            let playbookPayload = {
              organizationId: createdObject.organizationId,
              user: rootState.app.user,
              role: rootState.app.selectedOrganisation.role,
            };
            // dispatch.lifeCycle.getPacksAsync(playbookPayload);
            dispatch.lifeCycle.getCounts({ id: createdObject.organizationId });
          }
        }
      }
    },
    async handleUpdateEvent(payload, rootState) {
      if (rootState.app.isUserLoggedIn) {
        let entityId = null;
        const updatedObject = payload.updatedObject;
        if (updatedObject.eventKey === "suborgMoved"){
          entityId =  updatedObject.payload.teamIdToMove;
        }else {
          entityId = updatedObject._id ? updatedObject._id.toString() : updatedObject.accountUserId ? updatedObject.accountUserId.toString() : null;
        }
       
        const graph = Graph.fromObject(rootState.app.userCache);
        if (entityId && graph.hasVertex(entityId)) {
          dispatch.app.refreshCache();
        }
      }
    },
    async handlePatchEvent(payload, rootState) {
      const cacheConfigItem = payload.cacheConfigItem;
      // This is done to handle  KLM-2244
      if (cacheConfigItem.serviceName === "initiatives") {
        return;
      }
      //---

      if (rootState.app.isUserLoggedIn) {
        const patchedObject = payload.patchedObject;

        // const cacheConfigItem = payload.cacheConfigItem;
        const entityId = patchedObject && patchedObject._id ? patchedObject._id.toString() : "";

        //If logged in user object is being refreshed.
        if (rootState.app.user._id && rootState.app.user._id.toString() === entityId) {
          dispatch.app.setUser(
            Object.assign({}, rootState.app.user, patchedObject)
          );
        }

        if (rootState.app.userCache) {
          const graph = Graph.fromObject(rootState.app.userCache);
          if (graph.hasVertex(entityId)) {
            dispatch.app.refreshCache();
          }
        }
        if (cacheConfigItem.serviceName === "invites") {
          //if the invite is accepted, add the user in the graph is required
          if (patchedObject.isAccepted === true) {
            dispatch.app.refreshCache();
          }
        }

        if (cacheConfigItem.serviceName === "organizations") {
          if (
            rootState.app.baseModuleType === "Workspace" && rootState.app.selectedOrganisation._id &&
            entityId === rootState.app.selectedOrganisation._id.toString()
          ) {
            const loggedinUserId = rootState.app.user._id.toString();
            let isLoggedInUserPartOfOrg = false;
            patchedObject.users &&
              patchedObject.users.length > 0 &&
              patchedObject.users.forEach((user) => {
                if (user.accountUserId && user.accountUserId.toString() === loggedinUserId) {
                  isLoggedInUserPartOfOrg = true;
                }
              });

            if (!isLoggedInUserPartOfOrg) {
              toastr.error(
                "Message",
                `You do not have access to Organizaion "${patchedObject.name}"`
              );
              return dispatch(
                push("/app/" + patchedObject.accountId + "/dashboard")
              );
            }
          }
        }

        if (
          cacheConfigItem.serviceName === "contents" &&
          rootState.app.currentContext === "content" && rootState.app.user._id
        ) {
          const loggedInUserId = rootState.app.user._id.toString();
          if ( patchedObject.lastUpdatedBy && loggedInUserId !== patchedObject.lastUpdatedBy.toString()) {
            let contentPayload = {
              organizationId: patchedObject.organizationId,
              accountId: patchedObject.accountId,
              userid: loggedInUserId,
            };
            await dispatch.content.getAllContents(contentPayload);
            await dispatch.content.getContentsCount({
              organizationId: patchedObject.organizationId,
              accountId: patchedObject.accountId,
              value: "All",
            });
          }
        }

        if (
          cacheConfigItem.serviceName === "playbooks" &&
          rootState.app.currentContext === "designer" &&
          rootState.app.selectedOrganisation.id && patchedObject.organizationId &&
          rootState.app.selectedOrganisation.id.toString() ===
            patchedObject.organizationId.toString()
        ) {
          dispatch.lifeCycle.getCounts({ id: patchedObject.organizationId });
        }

        if ( patchedObject._id &&
          cacheConfigItem.serviceName === "accounts" &&
          rootState.app.selectedAccount._id === patchedObject._id
        ) {
          if (!patchedObject.isActive) {
            rootState.app.user.accounts.forEach((account) => {
              if (account.id === patchedObject._id) {
                account.isActive = false;
              }
            });
            dispatch.account.setDeActivateAccountModal(true);
            return dispatch(push("/app/" + patchedObject._id + "/dashboard"));
          } else {
            rootState.app.user.accounts.forEach((account) => {
              if (account.id === patchedObject._id) {
                account.isActive = true;
              }
            });
            dispatch.account.setDeActivateAccountModal(false);
          }
          await dispatch.app.setSelectedAccountData(patchedObject);
        }

        if (
          cacheConfigItem.serviceName === "accountusers" &&
          rootState.app.currentContext === "initiative"
        ) {
          if (
            rootState.app.routeParams.accountId.toString() ===
              rootState.app.selectedAccount._id.toString() &&
            rootState.app.routeParams.workspaceId.toString() ===
              rootState.app.selectedOrganisation._id.toString() &&
            rootState.app.routeParams.status === "active"
          ) {
            await dispatch.initiatives.getActiveInitiativeDetailsById(
              rootState.app.routeParams.initiativeId
            );
          }
        }

        if (
          cacheConfigItem.serviceName === "accountusers" &&
          rootState.app.currentContext === "activities"
        ) {
          if (  rootState.app.routeParams.accountId && rootState.app.selectedAccount._id && 
            rootState.app.routeParams.workspaceId && rootState.app.selectedOrganisation._id &&
            rootState.app.routeParams.accountId.toString() === 
              rootState.app.selectedAccount._id.toString() &&
            rootState.app.routeParams.workspaceId.toString() ===
              rootState.app.selectedOrganisation._id.toString()
          ) {
            let payload = {
              organizationId: rootState.app.routeParams.workspaceId,
              userId: rootState.app.user._id,
            };
            await dispatch.initiatives.getInitiativeActivitiesForMember(
              payload
            );
          }
        }
      }
    },
    async handleRemovedEvent(payload, rootState) {
      if (rootState.app.isUserLoggedIn) {
        const deletedObject = payload.deletedObject;
        const entityId = deletedObject._id.toString();
        const graph = Graph.fromObject(rootState.app.userCache);
        if (graph.hasVertex(entityId)) {
          dispatch.app.refreshCache();
        }
      }
    },
    async setAllOrganizations(payload, state) {
      const accountUserWorkspaces = await accountUserWorkspacesService.find({
        query: {
          accountId: payload.accountId,
          accountUserId: state.app.user._id,
        },
      });

      if (accountUserWorkspaces.data.length > 0) {
        let allOrganizations = {
          accountUserWorkspaces: accountUserWorkspaces.data[0].organizations,
        };
        await dispatch.app.setupNewOrganization(allOrganizations);
      }
      if(!payload.isUnAuthorized){
        return dispatch(push(`/app/${payload.accountId}/dashboard`));
      }
    },
    async setAllOrganizationsAndRedirectToDefault(payload, state) {
      const query = {
        accountId: payload.accountId,
        accountUserId: state.app.user._id,
        $select: ["organizations"],
      };
      const accountUserWorkspaces = await accountUserWorkspacesService.find({
        query,
      });

      if (accountUserWorkspaces.data.length > 0) {
        let allOrganizations = {
          accountUserWorkspaces: accountUserWorkspaces.data[0].organizations,
        };
        await dispatch.app.setupNewOrganization(allOrganizations);
        for (
          let i = 0;
          i < accountUserWorkspaces.data[0].organizations.length;
          i++
        ) {
          if (accountUserWorkspaces.data[0].organizations[i].default) {
            // If user has set Default workspace

            await dispatch.app.setSelectedOrganisationData(
              accountUserWorkspaces.data[0].organizations[i]
            );
            if (payload.isUnAuthorized) {
              return dispatch(push(`/app/${payload.accountId}/403`));
            }
            if(!payload.noDefaultAccountSelected){
              if (
                accountUserWorkspaces.data[0].organizations[i].role === "Member"
              ) {
                return dispatch(
                  push(
                    `/app/${payload.accountId}/_ws/${accountUserWorkspaces.data[0].organizations[i].id}/_at/myactivities`
                  )
                );
              } else {
                return dispatch(
                  push(
                    `/app/${payload.accountId}/_ws/${accountUserWorkspaces.data[0].organizations[i].id}/_pb`
                  )
                );
              }
            }
          }
        }
      } else {
        await dispatch.app.setupNewOrganization({
          accountUserWorkspaces: [],
        });
        // return dispatch(push(`/createWorkspace/${payload.accountId}`));
      }
      return dispatch(push(`/app/${payload.accountId}/dashboard`));
    },
    isDefaultSelected(payload) {
      dispatch.app.checkDefaultAccount(payload);
    },

    async getShowPricingTableEnv() {
      const isProd = await pricingTableService.find();
      dispatch.app.setShowPricingTableEnv(isProd);
    },

    showToolbar(payload) {
      dispatch.app.setShowToolbarFlag(payload);
    },
    showTeamListView(payload) {
      dispatch.app.setTeamListViewFlag(payload);
    },
    async downloadAttachment(payload, state) {
      try {
        let fileExtension = payload.documentName.split(".").pop().toLowerCase();

        let fileName = payload.documentId + "." + fileExtension;
        let query = {
          fileName: payload.documentName,
        };
        if (payload.isPublic) {
          query.accountId = "public";
          query.isPublic = true;
        }
        let fileData = await downloadFileService.get(fileName, {
          query: query,
        });
        let a = document.createElement("a");
        a.href = fileData.uri.href
        a.download = payload.documentName;
        a.click();
      } catch (e) {
        //console.warn("Error while downloading attchment - " + payload.documentName + " : " + e);
        throw e;
      }
    },

    async deleteAttachment(payload, state) {
      try {
        let fileExtension = payload.documentName.replace('/', '').split(".").pop().toLowerCase();

        let fileName = payload.documentId + "." + fileExtension;
        const deleteFileService = serviceFatcory.getProxy(
          `/attachment/${payload.entityName}/${payload.resourceId}`
        );
        await deleteFileService.remove(fileName, {
          query: {
            documentId: payload.documentId,
            accountId: state.app.selectedAccount._id,
          },
        });
      } catch (e) {
        //console.warn("Error while deleting attchment - " + payload.documentName + " : " + e);
        throw e;
      }
    },
    async getPublicCategoriesAsync() {
      try {
        const kb = await categoryPublicService.find();

        if (kb && kb.data && kb.data.length !== 0) {
          for (let i = 0; i < kb.data.length; i++) {
            kb.data[i].id = kb.data[i]._id;
            kb.data[i].text = kb.data[i].name;
            kb.data[i].value = kb.data[i].name;
            if (kb.data[i].categories && kb.data[i].categories.length !== 0) {
              for (let j = 0; j < kb.data[i].categories.length; j++) {
                kb.data[i].categories[j].id = kb.data[i].categories[j]._id;
                kb.data[i].categories[j].text = kb.data[i].categories[j].name;
                kb.data[i].categories[j].value = kb.data[i].categories[j].name;
                if (
                  kb.data[i].categories[j].subCategories &&
                  kb.data[i].categories[j].subCategories.length !== 0
                ) {
                  for (
                    let k = 0;
                    k < kb.data[i].categories[j].subCategories.length;
                    k++
                  ) {
                    kb.data[i].categories[j].subCategories[k].id =
                      kb.data[i].categories[j].subCategories[k]._id;
                    kb.data[i].categories[j].subCategories[k].text =
                      kb.data[i].categories[j].subCategories[k].name;
                    kb.data[i].categories[j].subCategories[k].value =
                      kb.data[i].categories[j].subCategories[k].name;
                  }
                }
              }
            }
          }
        }

        // dispatch.app.setPublicBasecategory(kb);
      } catch (err) {
        throw err;
      }
    },
    async updateUserPreference(payload) {
      dispatch.app.addPreferencesToUser(payload);
      try {
        await userPreferencesService.patch(payload._id, { $set: payload.data });
        dispatch.app.updatePreferencesToUser(payload.data);
      } catch (e) {
        throw e;
      }
    },
    async initiateSSOLogin(pathId) {
      try {
        localStorage.setItem(SSO_PATHID, pathId);
        dispatch.app.setSSOConfig(null);
        dispatch.app.setSSOConfigError(false);
        const config = await ssoConfigService.get(pathId);
        dispatch.app.setSSOConfig(config);
        authService = new AuthService(config);
        await authService.login();
      } catch (e) {
        dispatch.app.setSSOConfigError(true);
      }
    },
    async handleRedirect(payload, state) {
      const pathId = localStorage.getItem(SSO_PATHID);
      try {
        authService = new AuthService(state.app.ssoConfig);
        await authService.handleCallback();
        const tokenData = await authService.getToken();
        if (tokenData) {
          const payload = {
            strategy: "auth0",
            accessToken: tokenData,
            pathId: pathId,
            auth0Domain: "dev-7urjfmg0.us.auth0.com",
          };
          dispatch.login.loginSSO(payload);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async logout(payload, state) {
      const pathId = localStorage.getItem(SSO_PATHID);
      if (pathId) {
        dispatch.app.setSSOConfigError(false);
        dispatch.app.setSSOConfig(null);
        authService = new AuthService(payload);
        await authService.logout();
      }
    },
    async setUserPreference(payload) {
      try {
        await userPreferencesService.create(payload);
        dispatch.app.addPreferencesToUser(payload);
      } catch (e) {
        throw e;
      }
    },
  },
  selectors: {
    isUserLoggedIn: (state) => {
      return state.isUserLoggedIn;
    },
    getHelpContent: (state) => {
      return helpContext[state.helpContext];
    },
  },
};
